import {
  AckMessage,
  isCustomWindowMessageOfType,
  WindowMessage,
  WindowMessageType,
} from 'src/types/message';

const MAX_RETRY_COUNT = 30;

export const openPopupWithInitData = (
  popupUrl: string,
  dataMessage: Exclude<WindowMessage, AckMessage>,
  popupFeatures?: string
) => {
  const popup = window.open(
    popupUrl,
    `popup_${Math.random().toString(36).substring(2)}`,
    popupFeatures
  );

  if (!popup) return popup;

  let retryCount = 0;

  const cleanUp = () => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    clearInterval(pingTimer);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    window.removeEventListener('message', ackHandler);
  };

  // 팝업에서 메시지 처리 로직이 준비되기 까지 딜레이 고려
  const pingTimer = setInterval(() => {
    if (retryCount >= MAX_RETRY_COUNT || popup.closed) {
      cleanUp();
      return;
    }

    popup.postMessage(dataMessage);
    retryCount++;
  }, 100);

  const ackHandler = (event: MessageEvent) => {
    const message = event.data;

    if (
      isCustomWindowMessageOfType(message, WindowMessageType.Ack) &&
      message.respondingTo === dataMessage.type
    ) {
      cleanUp();
    }
  };

  window.addEventListener('message', ackHandler);

  return popup;
};

/**
 * 이미 열린 팝업에 메시지를 전송한다. ACK를 받을 때까지 100ms 간격으로 재시도한다.
 *
 * openPopupWithInitData와 달리 창을 새로 열지 않고 기존 WindowProxy를 받는다.
 * 주로 팝업 오픈 직후 비동기 작업(reserve API 등)이 완료됐을 때 결과를 팝업에 전달하기 위해 사용한다.
 * 팝업 로드 타이밍과 무관하게 안정적으로 메시지를 전달할 수 있다.
 */
export const sendMessageToPopupWithRetry = (
  popup: WindowProxy,
  dataMessage: Exclude<WindowMessage, AckMessage>
) => {
  let retryCount = 0;
  let pingTimer: ReturnType<typeof setInterval> | null = null;

  const cleanUp = () => {
    if (pingTimer) {
      clearInterval(pingTimer);
    }
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    window.removeEventListener('message', ackHandler);
  };

  pingTimer = setInterval(() => {
    if (retryCount >= MAX_RETRY_COUNT || popup.closed) {
      cleanUp();
      return;
    }

    popup.postMessage(dataMessage);
    retryCount++;
  }, 100);

  const ackHandler = (event: MessageEvent) => {
    const message = event.data;

    if (
      isCustomWindowMessageOfType(message, WindowMessageType.Ack) &&
      message.respondingTo === dataMessage.type
    ) {
      cleanUp();
    }
  };

  window.addEventListener('message', ackHandler);
};
